/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import useSegment from '../../../integrations/segment/app/hooks/use-segment'

/**
 * Simple ImageTile component that can be used inside any Layout component.
 * @param custom Object containing the image url, _type and focalPoint.
 * @returns {JSX.Element}
 */
export const ImageTile = (custom) => {
    const segment = useSegment()

    return (
        <Box
            className={'image-tile'}
            onClick={(event) => {
                // segment
                segment.sendPanelSelectedEvent(event, {})
            }}
        >
            <Box as={'figure'} className={'image-tile-figure'}>
                <picture>
                    <source
                        srcSet={custom?.image?.disBaseLink || custom?.image?.url}
                        media="(min-width: 48em)"
                    />
                    <source
                        srcSet={custom?.image?.disBaseLink || custom?.image?.url}
                        media="(min-width: 64em)"
                    />
                    <img
                        className={'image-tile-image'}
                        data-testid={'image-tile-image'}
                        src={custom?.image?.disBaseLink || custom?.image?.url}
                        alt={custom?.image?.disBaseLink || custom?.image?.url}
                    />
                </picture>
            </Box>
        </Box>
    )
}

ImageTile.propTypes = {
    custom: PropTypes.object
}

export default ImageTile
